import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators } from '@angular/forms';
import { BaseEntityComponent, BnLoadingService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { from, Observable, zip } from 'rxjs';
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { LimiteAgenteFinanceiro, LimiteFundoCadastro } from 'src/app/model/limite-agente-financeiro.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { LimiteService } from 'src/app/shared/services/limite.service';
import { OcorrenciaValidacaoVO } from '../../../shared/ocorrencia-validacao.vo';
import moment from "moment";
import { DataSistemaService } from 'src/app/shared/services/data-sistema.service';
import { ModalidadeService } from 'src/app/shared/services/modalidade.service';
import { Router } from '@angular/router';
import { ModalidadeGarantiaService } from "../../modalidade_garantia/modalidade-garantia.service";
import { RenunciaService } from '../../renuncia/renuncia.service';
import { consultaIpocExemplo } from 'src/app/model/consulta-ipoc.model';

@Component({
    selector: 'app-limite-fundo-cadastro',
    templateUrl: './limite-fundo-cadastro.component.html',
    styleUrls: ['./limite-fundo-cadastro.component.scss'],
    standalone: false
})
export class LimiteFundoCadastroComponent extends BaseEntityComponent<LimiteAgenteFinanceiro>
  implements OnInit {

  public utilizaRemuneracaoValidacaoLimiteFundo: boolean;

  public limiteFundoForm: UntypedFormGroup = null;
  ocorrencias: OcorrenciaValidacaoVO[] = [];

  usuarioPermitido: boolean;
  usuarioPodeEditar: boolean;
  private existeApuracaoRenuncia: boolean;
  private bimestreApuracaoRenuncia: number = 0;
  private valorTotalRenunciadoDescomprometidoApurado: number;
  private exibirCampoValorTotalNovo = true;
  private valorTotalNovoLimiteContratacao: number;
  private siglaModalidade: string;

  dataReferenciaDefault: Date;
  limiteFundoPrevio: LimiteFundoCadastro;
  limiteFundo: LimiteFundoCadastro;
  ehFGBS: boolean;

  vc: BnConfirmDirective;
  @ViewChild('formLimiteFundo', { static: false }) form: NgForm;


  constructor(
    protected injector: Injector,
    private modalService: BnModalMessageService,
    private permissaoService: PermissaoService,
    private loadingService: BnLoadingService,
    private limiteService: LimiteService,
    private dataSistemaService: DataSistemaService,
    private modalidadeService: ModalidadeService,
    private modalidadeGarantiaService: ModalidadeGarantiaService,
    private _router: Router,
    private fb: UntypedFormBuilder,
    private renunciaService: RenunciaService,

  ) {
    super(limiteService);
    this.config.rotaLista = '/limite/pesquisa';
  }

  ngOnInit() {
    this.loadingService.bloqueiaTela();

    this.modalidadeGarantiaService.buscarModalidade().subscribe((modalidade: any) => {
      this.siglaModalidade = modalidade.sigla;
      this.utilizaRemuneracaoValidacaoLimiteFundo = modalidade.utilizaRemuneracaoValidacaoLimiteFundo;
      this.ehFGBS = modalidade.sigla === 'FGBS';
      this.verificaPermissoes();
      this.buscarDadosLimite();

    });

  }

  public verificaPermissoes(): void {
    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.modalidadeService.modalidade$.subscribe((mod) => {

        if (resp && resp[ROLE_GESTOR_ENVIO] || resp && resp[ROLE_GESTOR_CONSULTA]) {
          this.usuarioPermitido = true;
          this.usuarioPodeEditar = resp[ROLE_GESTOR_ENVIO];
        } else {
          this._router.navigate(['nao-autorizado'])
        }
      });
    });
  }

  public buscarDadosLimite() {

    this.dataSistemaService.getDataCorrente().subscribe(dataCorrente => {
      this.dataReferenciaDefault = moment(dataCorrente).subtract(1, "month").endOf('month').toDate();

      this.limiteService.getLimiteFundo(dataCorrente).subscribe(limiteAtual => {
        this.limiteFundo = limiteAtual;
        this.modoEdicao = this.limiteFundo?.id != undefined ? false : true;

        if (limiteAtual) {
          const dataBuscaLimitePrevio = moment(limiteAtual.dataReferencia).subtract(1, "days").toDate();
          this.limiteService.getLimiteFundo(dataBuscaLimitePrevio).subscribe(limitePrevio => {
            this.limiteFundoPrevio = limitePrevio;
            this.construirFormulario();
            this.verificaExistenciaApuracaoRenuncia();

            this.loadingService.liberaTela();
          });
        } else {
          this.construirFormulario();
          this.verificaExistenciaApuracaoRenuncia();
          this.loadingService.liberaTela();
        }
      });
    },
      error => {
        this.trataErros(error);
      });
  }

  construirFormulario(): void {

    if (!this.limiteFundoForm) {
      this.limiteFundoForm = this.criarFormulario();
    }

    const dataReferencia = this.limiteFundo?.dataReferencia ? moment(this.limiteFundo?.dataReferencia).utcOffset(0)
      : this.dataReferenciaDefault;

    this.limiteFundoForm.patchValue({
      valorTotalLimitePrevio: this.limiteFundoPrevio?.valorTotalRecursosFundo,
      dataReferencia: dataReferencia,
      valorLimiteTotalContratacao: this.limiteFundo?.valorTotalRecursosFundo || null
    });


  }

  criarFormulario(): UntypedFormGroup {
    const form = this.fb.group({
      valorTotalLimitePrevio: [{ value: null, disabled: true }],
      dataReferencia: [{ value: null, disabled: true }, Validators.required],
      valorLimiteTotalContratacao: [{ value: null, disabled: this.limiteFundo?.id != undefined ? true : false }, [Validators.required, Validators.max(100000000000.00)]],
      comentarios: [{ value: null, disabled: this.limiteFundo?.id != undefined ? true : false }, Validators.minLength(3)],
      valorTotalRenunciadoDescomprometidoApurado: [{ value: null, disabled: true }],
      valorTotalNovoLimiteContratacao: [{ value: null, disabled: true }]

    });

    return form;
  }

  habilitarEdicao() {

    this.limiteFundoForm.get('dataReferencia').enable();
    this.limiteFundoForm.get('valorLimiteTotalContratacao').enable();
    this.limiteFundoForm.get('comentarios').enable();
    this.modoEdicao = true;
    super.editar();
  }

  desabilitaEdicao() {

    this.limiteFundoForm.get('dataReferencia').disable();
    this.limiteFundoForm.get('valorLimiteTotalContratacao').disable();
    this.limiteFundoForm.get('comentarios').disable();
    this.modoEdicao = false;
  }

  novoCadastro() {
    this.limiteFundoPrevio = this.limiteFundo;
    this.limiteFundo = null;

    let dataReferenciaSugerida = this.dataReferenciaDefault;
    if (!moment(this.limiteFundoPrevio?.dataReferencia).isBefore(moment(dataReferenciaSugerida))) {
      dataReferenciaSugerida = moment(this.limiteFundoPrevio?.dataReferencia).add(1, "days").toDate();
    }

    this.limiteFundoForm.patchValue({
      valorTotalLimitePrevio: this.limiteFundoPrevio?.valorTotalRecursosFundo,
      dataReferencia: dataReferenciaSugerida,
      valorLimiteTotalContratacao: null
    });

    this.limiteFundoForm.get('dataReferencia').enable();
    this.limiteFundoForm.get('valorLimiteTotalContratacao').enable();
    this.limiteFundoForm.get('comentarios').enable();
    this.modoEdicao = true;

    this.exibirCampoValorTotalNovo = false;

    this.bimestreApuracaoRenuncia = Number(this.bimestreApuracaoRenuncia);
    if(this.bimestreApuracaoRenuncia < 9){
      this.bimestreApuracaoRenuncia += 1;
    }

    super.editar();
  }

  salvar() {

    super.antesDeSalvar();

    this.ocorrencias = [];

    if (this.validarCampos()) {
      this.abreModalConfirmacao('Deseja confirmar o envio dos valores preenchidos?').subscribe((resp: {value: string}) => {
        if (resp?.value === 'ok') {
          this.limiteService.salvarOuAtualizarLimiteFundo(this.limiteFundo)
            .subscribe(() => {
              this.aposSalvar();
            }, error => {
              this.trataErros(error);
            });
        }
      });
    }
  }

  getParams(): LimiteFundoCadastro {
    const params: LimiteFundoCadastro = this.limiteFundoForm.getRawValue();
    return params;
  }

  validarCampos() {
    if (!this.limiteFundo) {
      this.limiteFundo = this.getParams();
    }

    const novaDataReferencia = moment(this.limiteFundoForm.get('dataReferencia').value).utcOffset(0);

    this.limiteFundo.dataReferencia = novaDataReferencia.toDate();
    this.limiteFundo.valorTotalRecursosFundo = this.limiteFundoForm.get('valorLimiteTotalContratacao').value;
    this.limiteFundo.comentarios = this.limiteFundoForm.get('comentarios').value;

    return true;
  }

  // @overide
  aposSalvar() {
    this.exibeMensagemSucesso();
    this.desabilitaEdicao();
    this.limiteFundo = null;
    this.buscarDadosLimite();
  }

  exibeMensagemSucesso(): void {
    this.messageService.addMessage({
      title: 'Sucesso',
      type: 'CRUD_OPERATION',
      level: messageLevel.SUCCESS,
      message: 'Limite criado/atualizado com sucesso.'
    });
  }

  exibirErro(erro: string) {
    this.messageService.addMessage({
      title: 'Erro',
      type: 'CRUD_OPERATION',
      level: messageLevel.ERROR,
      message: erro
    });
  }

  abreModalConfirmacao(mensagem: string): Observable<{value: string}> {
    const titulo = 'Confirmação';
    const resultadoConfimacao = this.modalService.abrirConfirm(titulo, mensagem).result;
    return from(resultadoConfimacao);
  }

  private trataErros(error) {
    console.log(error);
    this.ocorrencias = this.limiteService.ocorrencias;
    this.loadingService.liberaTela();
  }

  public verificaExistenciaApuracaoRenuncia() {

    this.renunciaService.getExistenciaApuracaoRenunciasPorModalidade().subscribe((qtdeApuracaoRenuncia: number) => {
      this.existeApuracaoRenuncia = qtdeApuracaoRenuncia > 0 ? true : false;
      this.carregaValoresApuracoesDistribuidos(this.existeApuracaoRenuncia);
    });

  }


  public carregaValoresApuracoesDistribuidos(existeApuracaoRenuncia: boolean) {


    if (existeApuracaoRenuncia) {

        this.renunciaService.getValoresApuracaoDistribuidos().subscribe(valoresDistribuidos => {

                this.bimestreApuracaoRenuncia = Number(valoresDistribuidos.bimestreApuracaoAtual);
                this.valorTotalRenunciadoDescomprometidoApurado = Number(valoresDistribuidos.valorTotalRenunciadoDescomprometidoApurado);

                let limiteTotalContratado: number = Number(this.limiteFundo?.valorTotalRecursosFundo);

                this.valorTotalNovoLimiteContratacao = limiteTotalContratado + this.valorTotalRenunciadoDescomprometidoApurado;

                this.limiteFundoForm.get('valorTotalRenunciadoDescomprometidoApurado').setValue(this.valorTotalRenunciadoDescomprometidoApurado);
                this.limiteFundoForm.get('valorTotalNovoLimiteContratacao').setValue(this.valorTotalNovoLimiteContratacao);
      });
    }

  }

  mudancaValor(valorLimiteTotal) {

      let valorAFormatar = valorLimiteTotal.replace(/[.]/g, "");
      let numeroFormatado = valorAFormatar.replace(',', '.');
      let valorAtualizado: number = Number(numeroFormatado);

      if (valorLimiteTotal !== null && valorAtualizado > 0) {

         this.exibirCampoValorTotalNovo = true;
         this.valorTotalNovoLimiteContratacao = valorAtualizado + this.valorTotalRenunciadoDescomprometidoApurado;
         this.limiteFundoForm.get('valorTotalNovoLimiteContratacao').setValue(this.valorTotalNovoLimiteContratacao);
      }

      else {
       this.exibirCampoValorTotalNovo = false;
      }


  }

  ehModalidadePEAC():boolean{
    return this.siglaModalidade === 'PEAC';
}


}
